
import React, { useRef, useState } from 'react';
import useMounted from '../../../hooks/useMounted';
import { get } from '../../../helpers/api_helper';
import { utc_local, amountFormat } from '../../../helpers/Helper';
import { GET_MY_SUBSCRIPTION } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import PaymentModal from '../../../components/PaymentModal';
import { Link } from 'react-router-dom';

const MySubscription = (props) => {
    const paymentModalRef = useRef();

    const [ShowLoader, SetShowLoader] = useState(false);
    const [active_plan_info, SetActive_plan_info] = useState(null);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);

    useMounted(() => {
        async function get_detaile() {
            getHomeDate();
        }
        get_detaile();
    }, [])

    const getHomeDate = async () => {
        SetShowLoader(true);
        var res_data = await get(GET_MY_SUBSCRIPTION);
        if (res_data.status) {
            SetActive_plan_info(res_data.data.active_plan_info);
            console.log(res_data.data.active_plan_info);
        } else {
            toast.error(res_data.message);
        }
        SetShowLoader(false);
    }

    const openModel = async (planId, subscriptionType, totalEmployees) => {
        SetButtonDisabled(true);
        paymentModalRef.current.openPaymentModel(planId, subscriptionType, totalEmployees);
    }


    return (
        <>
            {ShowLoader && <Loader />}



            <div className='row'>
                {(!ShowLoader && (!active_plan_info || !active_plan_info.subscriptionId)) &&
                    <div className="col-sm-12 col-lg-4 mb-4">
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <div className=" mb-0 pb-0 text-center">
                                    <i className="menu-icon tf-icons bx bx-file mb-3" style={{ "fontSize": "40px" }}></i>
                                    <h4>No Active Subscription</h4>
                                    <p>You don't have an active plan yet. Explore our subscription options to get started.</p>
                                    <Link to="/upgrade-plan" class="btn btn-sm btn-primary">Explore Plans</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {active_plan_info && active_plan_info.subscriptionId &&
                    <div className="col-sm-12 col-lg-6 mb-4">
                        <div className="card card-border-shadow-primary h-100">
                            <div className="card-body">
                                <h4>Current Subscription</h4>
                                <div className="price-bg-color p-3">
                                    {active_plan_info.plan_status && <span className='badge rounded-pill bg-warning text-dark mb-3'>{active_plan_info.status}</span>}
                                    {!active_plan_info.plan_status && <span className='badge rounded-pill bg-danger text-dark mb-3'>{active_plan_info.status}</span>}
                                    <h4 className="mb-3 text-white fw-bold">{active_plan_info.name}</h4>
                                    <div className='row'>
                                        <div className='col-sm-6 mb-3'>
                                            <p className="mb-0"><small>Team Size</small></p>
                                            <p className="mb-0">Up to {active_plan_info.totalEmployees} Employees</p>
                                        </div>
                                        <div className='col-sm-6 mb-3'>
                                            <p className="mb-0"><small>Subscription Type</small></p>
                                            <p className="mb-0">{active_plan_info.subscriptionType}</p>
                                        </div>
                                        <div className='col-sm-6 mb-3'>
                                            <p className="mb-0"><small>Billing Period</small></p>
                                            <p className="mb-0">{utc_local(active_plan_info.startDate, 'DD MMM')} To {utc_local(active_plan_info.endDate, 'DD MMM YYYY')}</p>
                                        </div>
                                        {active_plan_info.plan_status && <>
                                            <div className='col-sm-6 mb-3'>
                                                <p className="mb-0"><small>Next Billing</small></p>
                                                <p className="mb-0">{utc_local(active_plan_info.endDate, 'DD MMM YYYY')}</p>
                                            </div>
                                            <div className='col-sm-6 mb-3'>
                                                <p className="mb-0"><small>Next Billing Amount</small></p>
                                                <p className="mb-0">₹{amountFormat(active_plan_info.nextBillAmount)}</p>
                                            </div>
                                        </>}
                                    </div>
                                </div>

                                {!active_plan_info.plan_status && <div className='mt-3'>
                                    <button onClick={() => { openModel(active_plan_info.planId ,active_plan_info.subscriptionType,active_plan_info.totalEmployees) }} disabled={ButtonDisabled} className='btn w-100 btn-primary'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Renew Now  For {active_plan_info.name} Plan One {active_plan_info.subscriptionType === 'Monthly' ? 'Month': 'Year'} ₹{amountFormat(active_plan_info.nextBillAmount)}</button>
                                </div>}
                            </div>
                        </div>
                    </div>
                }
            </div>

            <PaymentModal ref={paymentModalRef} call_back={() => { SetButtonDisabled(false) }} />

        </>
    );
}

export default MySubscription;